import { useAppSelector } from 'hooks/reduxHooks'
import { getAgentHubCommissionForOffer } from 'agentHub/selectors/agentHubSelectors'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
interface UseAgentHubCommissionLabelResult {
  showCommissionLabel: boolean
  additionalCommissionPercentage: number | undefined
  baseCommissionPercentage: number | undefined
}

/**
 * Hook to determine if the additional commission label should be shown for an offer
 * @param offerId - The offer ID to check commission for
 * @param packageId - Optional package ID for package-specific commission
 * @returns Object with showCommissionLabel boolean and commissionPercentage
 */
function useAgentHubCommissionLabel(offerId: string | undefined, packageId?: string | undefined): UseAgentHubCommissionLabelResult {
  const commissionForOffer = useAppSelector(state => getAgentHubCommissionForOffer(state, offerId))

  if (!isAgentHubEnabled) {
    return {
      showCommissionLabel: false,
      additionalCommissionPercentage: undefined,
      baseCommissionPercentage: undefined,
    }
  }

  const dueCommission = packageId
    ? commissionForOffer?.packages.find(pkg => pkg.packageId === packageId)
    : commissionForOffer

  const showCommissionLabel = !!(
    dueCommission?.additionalCommissionsPercentage &&
    dueCommission?.baseCommissionPercentage
  )

  return {
    showCommissionLabel,
    additionalCommissionPercentage: dueCommission?.additionalCommissionsPercentage,
    baseCommissionPercentage: dueCommission?.baseCommissionPercentage,
  }
}

export default useAgentHubCommissionLabel
